module.exports = __webpack_public_path__ + "static/media/Rewind-10s-Splash.05b92650.png";